import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';
import Tooltip, { tooltipClasses } from '@zenbusiness/zui/Tooltip';

const TooltipIconStyles = ({ theme }) => ({
  cursor: 'pointer',
  borderRadius: '50%',
  '&:hover': {
    backgroundColor: theme.palette.background.grey.main
  },
  '&:active': {
    backgroundColor: theme.palette.background.grey.main
  }
});

export const TooltipIcon = styled(Stack)(TooltipIconStyles);

export const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip
    {...props}
    arrow
    classes={{ popper: className }}
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.text.primary
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.fixed.black,
    borderRadius: 12,
    padding: 16
  }
}));
